const OPTIMIZER_WARNING_COPY = {
  TARGET_CM_NOT_ACHIEVED: "Target CM not achieved",
  TARGET_CM_COULD_NOT_BE_ACHIEVED: "Target CM could not be achieved",
  CANNIBALIZATION_RISK: "Cannibalization risk",
  MUST_PROMOTE_WEEKS: "Must promote weeks",
  MUST_PROMOTE: "Must promote",
  HIGH_CANNIBALIZATION: "High cannibalization risk",
};

function isLikelyApiSentence(str) {
  return /\s/.test(str) && /[a-z]/.test(str);
}

/**
 */
export function displayOptimizerWarning(raw) {
  if (raw == null) return "";
  const s = String(raw).trim();
  if (!s) return "";
  if (OPTIMIZER_WARNING_COPY[s]) return OPTIMIZER_WARNING_COPY[s];
  if (isLikelyApiSentence(s)) return s.replace(/\s+/g, " ");
  return s
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .replace(/^\w/, (c) => c.toUpperCase());
}

export function friendlyPromoWarning(raw) {
  if (raw == null) return "";
  const s = String(raw).trim();
  if (!s) return "";
  if (isLikelyApiSentence(s)) return s.replace(/\s+/g, " ");

  return s
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();
}
